export default { sha: '39a56dcc1c715f1ba6aebdeffb2378e415f606f2', buildNumber: 'undefined' }
